import React from "react";
import "./discussion-tab-content.component.scoped.scss";
import { WorkflowTimelineComponent } from "./components/workflow-timeline/workflow-timeline.component";

const DiscussionTabContentComponent = () => {
  return <WorkflowTimelineComponent />;
};

export default DiscussionTabContentComponent;
